import { Route, Routes } from "react-router-dom";
import { EngineHistory } from "./list";

export const EngineHistoryRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<EngineHistory />} />
    </Routes>
  );
};
